import React, { useState, useEffect } from "react";
import { BsWhatsapp } from "react-icons/bs";

const WhatsAppFAB = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show FAB after scrolling past hero section (approximately viewport height)
      setIsVisible(window.scrollY > window.innerHeight * 0.7);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Check initial position

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <a
      href="https://wa.me/96103644705"
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-5 right-5 z-50 w-11 h-11 bg-green-500 text-white
                 rounded-full shadow-[0_0_20px_rgba(34,197,94,0.5)] hover:shadow-[0_0_30px_rgba(34,197,94,0.7)]
                 hover:bg-green-600 hover:scale-110
                 transition-all duration-300 flex items-center justify-center
                 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10 pointer-events-none"}`}
      aria-label="Chat on WhatsApp"
    >
      <BsWhatsapp className="w-5 h-5" />
    </a>
  );
};

export default WhatsAppFAB;
